import Image from "next/image";
import ScifreeLogo from "../../../public/poweredbyscifree.png";
import "./footer.scss";
import { I18nData } from "@/types/i18n";

interface FooterProps {
  i18nData?: I18nData;
  locale?: string;
}

export default function Footer({ i18nData, locale = 'en' }: FooterProps) {
  const lang = i18nData?.[locale] || i18nData?.en;
  return (
    <footer role="contentinfo" aria-label="Page footer">
      <a
        href="https://scifree.se"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Click this link to reach the SciFree website"
        title="Link to SciFree website"
        id="logoToSciFree"
      >
        <Image
          src={ScifreeLogo}
          alt="Scifree Logo"
          height={36}
          width={100}
          id="poweredByIcon"
          style={{
            width: 'auto',
            height: 'auto'
          }}
        />
      </a>
      <div id="link-wrapper">
        <a
          href="https://scifree.se/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          id="policy"
          aria-label="Click this link to reach the SciFree Privacy Policy"
          title="Link to SciFree Privacy Policy"
        >
          {lang?.privacy_policy_text ?? "Privacy policy"}
        </a>
        <a
          href="https://scifree.se/accessibility"
          target="_blank"
          rel="noopener noreferrer"
          id="accessibility"
          aria-label="Click this link to reach the SciFree Accessibility page"
          title="Link to SciFree Accessibility page"
        >
          {lang?.accessibility_text ?? "Accessibility"}
        </a>
      </div>
    </footer>
  );
}
